import React, { useState } from "react";
import { Box, Typography, Container } from "@mui/material";
import Buy from "../../assets/svgs/Buy.svg";
import Pro from "../../assets/svgs/Pro.svg";
import Auction from "../../assets/svgs/Auction.svg";
import Spare from "../../assets/svgs/spare-part.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import FeatureCard from "../common/FeatureCard/FeatureCard";
import ExploreCategories from "./ExploreCategories";
import CategoriesModal from "../common/Modal/CategoriesModal";

function ExploreSection() {
  const mobileMatch = useMediaQuery("(max-width:600px)");
  return (
    <>
      <Box
        sx={{
          height: "100%",
          marginY: { xs: "16px", sm: "72px" },
          display: "flex",
          flexFlow: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!mobileMatch && (
          <Typography variant="h2" sx={{ fontSize: "32px", fontWeight: "700" }}>
            Explore
          </Typography>
        )}
        <Container
          sx={{
            padding: "0px",
            marginTop: { xs: "", sm: "32px" },
            display: "flex",
            flexFlow: { xs: "column", md: "row" },
            justifyContent: "center",
            alignItems: "center",
            columnGap: "24px",
            rowGap: { xs: "16px", sm: "24px" },
          }}
        >
          {mobileMatch ? <ExploreCategories /> : ""}
          <FeatureCard
            img={Buy}
            cardTitle="Machinery for Buy"
            cardDesc="Find your place with an immersive photo experience and most listings, including things you won't find anywhere else."
            cardActionText="Buy Machinery"
          />
          <FeatureCard
            img={Pro}
            cardTitle="Pro Machinery"
            cardDesc="Find your place with an immersive photo experience and most listings, including things you won't find anywhere else."
            cardActionText="Explore Pro"
          />
          <FeatureCard
            img={Auction}
            cardTitle="Machinery for Auction"
            cardDesc="Find your place with an immersive photo experience and most listings, including things you won't find anywhere else."
            cardActionText="Explore Auction"
          />
        </Container>
      </Box>
    </>
  );
}

export default ExploreSection;
